import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";

export const labMachineAnalysisUseStyle = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
    },
    spaceBetweenInputs: {
      marginTop: theme.spacing(2),
    },
    filters: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
    },
    titleSpacing: {
      marginTop: theme.spacing(5),
      marginBottom: theme.spacing(5),
    },
  }),
);
